<template>
  <div>
    <h2>배너 미리보기</h2>
    <div v-if="banner" class="banner-section">
      <div class="banner-text-box">
        <p class="banner-title" :style="{color: banner.textColor}">{{banner.title | normalize}}</p>
        <p class="banner-desc" :style="{color: banner.textColor}" v-html="banner.description" />
      </div>

      <div class="banner-btn">
        <template v-if="banner.linkVisible && banner.linkUrl">
          <a v-if="banner.linkUrl.startsWith('http')" :href="banner.linkUrl" target="_blank"
             class="more" :style="{color: banner.textColor, border: `solid 2px ${banner.textColor}`}"><span>{{banner.linkText}}</span></a>
          <router-link v-else :to="{path: banner.linkUrl}" class="more"
                       :style="{color: banner.textColor, border: `solid 2px ${banner.textColor}`}"
          ><span>{{banner.linkText}}</span></router-link>
        </template>
      </div>

      <div class="banner-bg" v-if="banner.img1 !== ''"
           :style="{backgroundImage: `url(${publicPath}upload/main_banner/${banner.img1})`}"></div>
    </div>

    <template v-if="banner && banner.img2 !== null && banner.img2 !== ''">
      <h5>배너 이미지(Mobile)<small class="text-muted ml-3">{{banner.img2}}</small></h5>
      <img :src="`${publicPath}upload/main_banner/${banner.img2}`" />
    </template>

    <div class="card mt-5">
      <div class="card-header">
        <h2>배너 부가정보</h2>
      </div>
      <div class="card-body" v-if="banner">
        <dl class="row">
          <dt class="col-sm-3">버튼 노출</dt>
          <dd class="col-sm-9">{{banner.linkVisible ? '노출' : '숨김'}}</dd>
          <dt class="col-sm-3">버튼 텍스트</dt>
          <dd class="col-sm-9">{{banner.linkText}}</dd>
          <dt class="col-sm-3">버튼 링크</dt>
          <dd class="col-sm-9">{{banner.linkUrl}}</dd>
        </dl>
      </div>
    </div>


    <div class="text-center my-3" v-if="banner">
      <router-link
        tag="button"
        class="btn btn-outline-secondary mx-1"
        :to="{name:'adminMainEdit', params: {id: banner.id}}">
        수정
      </router-link>
      <button type="button" class="btn btn-outline-danger mx-1" @click="remove">삭제</button>
      <button type="button" class="btn btn-outline-secondary mx-1" @click="$router.back()">목록</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AdminMainView',
  data() {
    return {
      banner: null,
    };
  },
  mounted() {
    if (this.$route.params && this.$route.params.id) {
      this.axios.get(`/admin/main/${this.$route.params.id}`)
        .then(({ data }) => {
          this.banner = data;
        })
        .catch(() => {
          this.$router.push({ name: 'adminMainList' });
        });
    }
  },
  methods: {
    remove() {
      // eslint-disable-next-line no-restricted-globals,no-alert
      if (confirm('삭제하시겠습니까?')) {
        this.$axios.delete(`/admin/main/${this.banner.id}`)
          .then(() => {
            this.$router.push({ name: 'adminMainList' });
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .banner-section {
    position: relative;
    overflow: hidden;
    padding-top: 135px;
    text-align: center;
    line-height: 1.5em;
    background-color: #fafafa;
    height: 940px;
    box-sizing: border-box;
    width: 100%;

    .banner-text-box {
      position: relative;
      z-index: 5;

      .banner-title {
        font-size: 68px;
        color: #0c1e2b;
        font-weight: 700;
        line-height: 1.25em;
      }

      .banner-desc {
        font-size: 32px;
        margin-top: 15px;
        padding: 0 15px;
        color: #0c1e2b;
        font-weight: 500;
        line-height: 1.35em;
      }
    }

    .banner-btn {
      display: inline-block;
      position: relative;
      margin-top: 35px;
      width: 360px;
      height: 84px;
      line-height: 84px;
      font-size: 26px;
      color: #0c1e2b;
      font-weight: 700;
      text-align: center;
    }

    .banner-bg {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: #000;
      background-position: center;
      background-size: cover;
    }
  }
</style>
